import { getEnv } from '~/utils/env';

export const getGcpProjectId = (): string | undefined => getEnv('GCP_PROJECT_ID');

export const getGoogleApiKey = (): string | undefined => getEnv('GOOGLE_API_KEY');

export function getRecaptchaInvisibleSiteKey(): string {
  const siteKey = getEnv('NEXT_PUBLIC_GOOGLE_RECAPTCHA_INVISIBLE_SITEKEY');

  if (!siteKey) {
    console.warn('Google captcha site key is not provided.');
    return '';
  }

  return siteKey;
}
